import React, { Component } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";

import { loadAgents } from "../../store/actions/agentAction";
import { loadLots } from "../../store/actions/lotAction";
import { loadLocations } from "../../store/actions/locationAction";
import { loadMenages } from "../../store/actions/menageAction";

import { columns } from "./columns";

import ListMenage from "../../components/ListMenage";

class Menages extends Component {
  componentDidMount() {
    this.props.loadAgents();
    this.props.loadLots();
    this.props.loadLocations();
    this.props.loadMenages();
  }

  render() {
    const { agents, lots, locations, menages } = this.props;

    return (
      <Spin spinning={!menages} size="large" tip="Chargement en cours..." wrapperClassName="view-spin">
        <ListMenage
          listData={menages}
          agents={agents}
          lots={lots}
          locations={locations}
          tableOption={columns}
        />
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadAgents: () => dispatch(loadAgents()),
    loadLots: () => dispatch(loadLots()),
    loadLocations: () => dispatch(loadLocations()),
    loadMenages: () => dispatch(loadMenages()),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    agents: state.agents.data,
    lots: state.lots.data,
    locations: state.locations.data,
    menages: state.menages.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Menages);
